// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../common/Components/menu/MenuV5.bs.js");
let DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let NotificationSettingsComponents = require("./NotificationSettingsComponents.bs.js");
let NotificationSettingsPreferenceEditDialogAreaGroups = require("./NotificationSettingsPreferenceEditDialogAreaGroups.bs.js");
let NotificationSettingsNewDevelopments_chapter_graphql = require("../../__generated__/NotificationSettingsNewDevelopments_chapter_graphql.bs.js");
let NotificationSettingsNewDevelopments_areaGroup_graphql = require("../../__generated__/NotificationSettingsNewDevelopments_areaGroup_graphql.bs.js");
let NotificationSettingsNewDevelopments_notificationSetting_graphql = require("../../__generated__/NotificationSettingsNewDevelopments_notificationSetting_graphql.bs.js");
let NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql = require("../../__generated__/NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.bs.js");
let NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql = require("../../__generated__/NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.bs.js");

let convertFragment = NotificationSettingsNewDevelopments_notificationSetting_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsNewDevelopments_notificationSetting_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsNewDevelopments_notificationSetting_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsNewDevelopments_notificationSetting_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsNewDevelopments_notificationSetting_graphql.node, convertFragment, fRef);
}

let NotificationSettingFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let areaTypeV5_decode = NotificationSettingsNewDevelopments_areaGroup_graphql.Utils.areaTypeV5_decode;

let matchableEntityType_decode = NotificationSettingsNewDevelopments_areaGroup_graphql.Utils.matchableEntityType_decode;

let convertFragment$1 = NotificationSettingsNewDevelopments_areaGroup_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsNewDevelopments_areaGroup_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsNewDevelopments_areaGroup_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsNewDevelopments_areaGroup_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsNewDevelopments_areaGroup_graphql.node, convertFragment$1, fRef);
}

let AreaGroupFragment_areaTypeV5_fromString = NotificationSettingsNewDevelopments_areaGroup_graphql.Utils.areaTypeV5_fromString;

let AreaGroupFragment_matchableEntityType_fromString = NotificationSettingsNewDevelopments_areaGroup_graphql.Utils.matchableEntityType_fromString;

let AreaGroupFragment = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: AreaGroupFragment_areaTypeV5_fromString,
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: AreaGroupFragment_matchableEntityType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = NotificationSettingsNewDevelopments_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsNewDevelopments_chapter_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsNewDevelopments_chapter_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsNewDevelopments_chapter_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsNewDevelopments_chapter_graphql.node, convertFragment$2, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let convertVariables = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertVariables;

let convertResponse = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables, NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_decode = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_fromString = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.broadcastMessageNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_decode = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.developmentNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_fromString = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.developmentNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_decode = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_decode;

let UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_fromString = NotificationSettingsNewDevelopments_UpdateUserNotificationSettingsV5Mutation_graphql.Utils.entityNotificationPreferenceSettingV5_fromString;

let UpdateUserNotificationSettingsV5Mutation = {
  broadcastMessageNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_broadcastMessageNotificationPreferenceSettingV5_fromString,
  developmentNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_decode,
  developmentNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_developmentNotificationPreferenceSettingV5_fromString,
  entityNotificationPreferenceSettingV5_decode: UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_decode,
  entityNotificationPreferenceSettingV5_fromString: UpdateUserNotificationSettingsV5Mutation_entityNotificationPreferenceSettingV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$3
};

let convertVariables$1 = NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertVariables;

let convertResponse$1 = NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$4 = RescriptRelay_Mutation.useMutation(convertVariables$1, NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_decode = NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_fromString = NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_decode = NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.propertyNotificationPreferenceMLSStatus_decode;

let UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_fromString = NotificationSettingsNewDevelopments_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.propertyNotificationPreferenceMLSStatus_fromString;

let UpdateUserNotificationPreferenceV5Mutation = {
  forSalePropertyTypeEnumV5_decode: UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$4
};

function settingToString(p) {
  if (p === "CHAPTER_DEFAULT") {
    return "All new developments in my chapter";
  } else {
    return "Custom areas";
  }
}

function NotificationSettingsNewDevelopments$DevelopmentSettingsSelector(props) {
  let onChange = props.onChange;
  let value = props.value;
  let disabled = props.disabled;
  let settings = [
    "CHAPTER_DEFAULT",
    "CUSTOM"
  ];
  return JsxRuntime.jsx(MenuV5.Menu.make, {
    button: JsxRuntime.jsx(ButtonsV5.Button.make, {
      className: "!font-normal !normal-case !py-2",
      children: JsxRuntime.jsxs("div", {
        children: [
          settingToString(value),
          JsxRuntime.jsx(IconV5.make, {
            icon: "arrow-down",
            size: 14,
            className: "text-gray-500"
          })
        ],
        className: "flex items-center justify-between gap-4 "
      })
    }),
    children: settings.map(setting => JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => onChange(setting),
      isDisabled: disabled || setting === value,
      children: settingToString(setting)
    }, setting))
  });
}

let DevelopmentSettingsSelector = {
  settingToString: settingToString,
  make: NotificationSettingsNewDevelopments$DevelopmentSettingsSelector
};

function areasFromFragmentAreas(areas) {
  return Stdlib_Array.filterMap(Stdlib_Array.keepSome(Stdlib_Option.getOr(areas, [])), area => Stdlib_Option.map(areaTypeV5_decode(area.type_), type_ => ({
    id: area.id,
    label: area.label,
    type_: type_
  })));
}

function NotificationSettingsNewDevelopments(props) {
  let onFailed = props.onFailed;
  let onSuccess = props.onSuccess;
  let notificationSetting = RescriptRelay_Fragment.useFragment(NotificationSettingsNewDevelopments_notificationSetting_graphql.node, convertFragment, props.notificationSetting);
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettingsNewDevelopments_chapter_graphql.node, convertFragment$2, props.chapter);
  let match = use$3();
  let isUpdatingSetting = match[1];
  let updateUserNotificationSettings = match[0];
  let match$1 = use$4();
  let isUpdatingPreference = match$1[1];
  let updateUserNotificationPreference = match$1[0];
  let match$2 = React.useState(() => false);
  let setIsEditing = match$2[1];
  let hasGNSFeature = UserSession.useHasPlanFeature("GNS");
  let match$3 = React.useState(() => false);
  let setShowUpgradeDialog = match$3[1];
  let match$4 = notificationSetting.developments;
  let selectedSetting;
  if (match$4 !== undefined) {
    switch (match$4.__typename) {
      case "ChapterDefaultNotificationSetting" :
        selectedSetting = "CHAPTER_DEFAULT";
        break;
      case "CustomDevelopmentNotificationPreference" :
        selectedSetting = "CUSTOM";
        break;
      case "__unselected" :
        selectedSetting = undefined;
        break;
    }
  } else {
    selectedSetting = undefined;
  }
  let match$5 = notificationSetting.developments;
  let userHasInactiveCustomPreference;
  if (match$5 !== undefined) {
    switch (match$5.__typename) {
      case "ChapterDefaultNotificationSetting" :
        userHasInactiveCustomPreference = match$5.userHasInactiveCustomPreference;
        break;
      case "CustomDevelopmentNotificationPreference" :
      case "__unselected" :
        userHasInactiveCustomPreference = false;
        break;
    }
  } else {
    userHasInactiveCustomPreference = false;
  }
  let match$6 = notificationSetting.developments;
  let tmp;
  if (match$6 !== undefined) {
    switch (match$6.__typename) {
      case "CustomDevelopmentNotificationPreference" :
        let match$7 = match$6.areaGroup;
        tmp = match$7 !== undefined ? Primitive_option.some(match$7.fragmentRefs) : undefined;
        break;
      case "ChapterDefaultNotificationSetting" :
      case "__unselected" :
        tmp = undefined;
        break;
    }
  } else {
    tmp = undefined;
  }
  let customAreaGroup = useOpt$1(tmp);
  let initialAreaGroup = () => {
    if (customAreaGroup === undefined) {
      return {
        TAG: "NewAreaGroup",
        areas: []
      };
    }
    let unselectedAreaGroupType = customAreaGroup.byType;
    let areas = customAreaGroup.areas;
    switch (unselectedAreaGroupType.__typename) {
      case "ChapterAreaGroup" :
        return {
          TAG: "ChapterAreaGroup",
          id: customAreaGroup.id,
          areas: areasFromFragmentAreas(areas)
        };
      case "UserAreaGroup" :
        return {
          TAG: "UserAreaGroup",
          id: customAreaGroup.id,
          areas: areasFromFragmentAreas(areas),
          usedFor: Stdlib_Array.filterMap(Stdlib_Option.getOr(unselectedAreaGroupType.usedFor, []), v => matchableEntityType_decode(v))
        };
      case "__unselected" :
        return UnselectedUnionMemberError.raise(`Unselected area group type: ` + unselectedAreaGroupType._0);
    }
  };
  let match$8 = React.useState(initialAreaGroup);
  let setAreaGroup = match$8[1];
  let areaGroup = match$8[0];
  let areaGroupHasAreas;
  switch (areaGroup.TAG) {
    case "UserAreaGroup" :
    case "ChapterAreaGroup" :
      areaGroupHasAreas = areaGroup.areas.length !== 0;
      break;
    case "NewAreaGroup" :
      areaGroupHasAreas = areaGroup.areas.length !== 0;
      break;
  }
  let customAreaGroupHasAreas = customAreaGroup !== undefined ? Stdlib_Array.keepSome(Stdlib_Option.getOr(customAreaGroup.areas, [])).length !== 0 : false;
  let save = () => {
    let areas;
    let exit = 0;
    let areas$1;
    switch (areaGroup.TAG) {
      case "UserAreaGroup" :
      case "ChapterAreaGroup" :
        areas$1 = areaGroup.areas;
        exit = 1;
        break;
      case "NewAreaGroup" :
        areas$1 = areaGroup.areas;
        exit = 1;
        break;
    }
    if (exit === 1) {
      areas = areas$1.map(area => ({
        areaId: area.id
      }));
    }
    let areaGroup$1;
    switch (areaGroup.TAG) {
      case "UserAreaGroup" :
        areaGroup$1 = {
          __$inputUnion: "userAreaGroup",
          _0: {
            areas: areas,
            id: areaGroup.id
          }
        };
        break;
      case "ChapterAreaGroup" :
        areaGroup$1 = {
          __$inputUnion: "chapterDefault",
          _0: true
        };
        break;
      case "NewAreaGroup" :
        areaGroup$1 = {
          __$inputUnion: "newUserAreaGroup",
          _0: {
            areas: areas
          }
        };
        break;
    }
    updateUserNotificationPreference({
      input: {
        __$inputUnion: "developments",
        _0: {
          areaGroup: areaGroup$1
        }
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateUserNotificationPreferenceV5 = param.updateUserNotificationPreferenceV5;
      if (updateUserNotificationPreferenceV5 !== undefined && updateUserNotificationPreferenceV5.__typename === "UserNotificationPreferenceWasUpdated") {
        onSuccess();
        return setIsEditing(param => false);
      }
      onFailed();
      setIsEditing(param => false);
    }, undefined, undefined);
  };
  if (selectedSetting === undefined) {
    return null;
  }
  let tmp$1;
  tmp$1 = selectedSetting === "CHAPTER_DEFAULT" ? null : JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      onClick: param => {
        if (hasGNSFeature) {
          setAreaGroup(param => initialAreaGroup());
          return setIsEditing(param => true);
        } else {
          return setShowUpgradeDialog(param => true);
        }
      },
      disabled: isUpdatingSetting || isUpdatingPreference,
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(IconV5.make, {
            icon: "pencil"
          }),
          JsxRuntime.jsx("span", {
            children: "Edit areas",
            className: "text-base font-normal capitalize"
          })
        ],
        className: "flex flex-row space-x-2 py-0.5"
      })
    });
  let match$9 = notificationSetting.developments;
  let tmp$2;
  if (match$9 !== undefined) {
    switch (match$9.__typename) {
      case "CustomDevelopmentNotificationPreference" :
        let areaGroup$1 = match$9.areaGroup;
        let exit = 0;
        if (areaGroup$1 !== undefined && customAreaGroupHasAreas) {
          tmp$2 = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(NotificationSettingsComponents.AreaGroupItem.make, {
              areaGroup: areaGroup$1.fragmentRefs,
              chapter: chapter.fragmentRefs
            }),
            className: "p-2"
          });
        } else {
          exit = 1;
        }
        if (exit === 1) {
          tmp$2 = JsxRuntime.jsx("div", {
            children: "No custom areas selected yet. Use Edit areas to choose at least one area.",
            className: "mt-2 p-2 text-sm text-orange-700"
          });
        }
        break;
      case "ChapterDefaultNotificationSetting" :
      case "__unselected" :
        tmp$2 = null;
        break;
    }
  } else {
    tmp$2 = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
            children: "New developments"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
              children: [
                `You will receive new development emails for broadcasts in your selected areas.`,
                JsxRuntime.jsx("br", {}),
                `Which new development emails do you want to receive?`
              ],
              className: "leading-relaxed"
            })
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(NotificationSettingsNewDevelopments$DevelopmentSettingsSelector, {
                disabled: isUpdatingSetting || isUpdatingPreference,
                value: selectedSetting,
                onChange: v => {
                  if (v !== "CHAPTER_DEFAULT") {
                    if (!hasGNSFeature) {
                      return setShowUpgradeDialog(param => true);
                    }
                    if (!userHasInactiveCustomPreference) {
                      setAreaGroup(param => initialAreaGroup());
                      return setIsEditing(param => true);
                    }
                  }
                  updateUserNotificationSettings({
                    input: {
                      __$inputUnion: "developments",
                      _0: v
                    }
                  }, undefined, undefined, undefined, (param, param$1) => {
                    let updateUserNotificationSettingsV5 = param.updateUserNotificationSettingsV5;
                    if (updateUserNotificationSettingsV5 !== undefined && updateUserNotificationSettingsV5.__typename === "UserNotificationSettingsWasUpdated") {
                      return onSuccess();
                    } else {
                      return onFailed();
                    }
                  }, undefined, undefined);
                }
              }),
              tmp$1
            ],
            className: "flex flex-row items-center gap-4 mt-4 flex-wrap"
          }),
          tmp$2
        ],
        className: "mt-7"
      }),
      match$2[0] ? JsxRuntime.jsx(DialogV5.make, {
          title: "Edit new development notification areas",
          isOpen: true,
          ariaLabel: "Edit new development notification areas",
          onDismiss: () => setIsEditing(param => false),
          size: "XXLarge",
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups.make, {
                chapter: chapter.fragmentRefs,
                settings: notificationSetting.fragmentRefs,
                currentAreaGroup: areaGroup,
                setAreaGroup: areaGroup => setAreaGroup(param => areaGroup),
                preferenceType: "NEW_DEVELOPMENT",
                fieldResult: areaGroupHasAreas ? ({
                    TAG: "Ok",
                    _0: areaGroup
                  }) : ({
                    TAG: "Error",
                    _0: "Select at least one area"
                  }),
                includeChapterDefault: false
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                      onClick: param => setIsEditing(param => false),
                      size: "huge",
                      children: "Cancel"
                    }),
                    className: "mr-16"
                  }),
                  JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                    onClick: e => {
                      e.preventDefault();
                      save();
                    },
                    disabled: !areaGroupHasAreas || isUpdatingPreference,
                    size: "large",
                    children: "Save Changes"
                  })
                ],
                className: "flex flex-row items-baseline justify-end mt-4 p-4"
              })
            ],
            className: "w-full bg-white"
          })
        }) : null,
      JsxRuntime.jsx(NotificationSettingsComponents.UpgradeToProDialog.make, {
        isOpen: match$3[0],
        onClose: () => setShowUpgradeDialog(param => false)
      })
    ]
  });
}

let make = NotificationSettingsNewDevelopments;

exports.NotificationSettingFragment = NotificationSettingFragment;
exports.AreaGroupFragment = AreaGroupFragment;
exports.ChapterFragment = ChapterFragment;
exports.UpdateUserNotificationSettingsV5Mutation = UpdateUserNotificationSettingsV5Mutation;
exports.UpdateUserNotificationPreferenceV5Mutation = UpdateUserNotificationPreferenceV5Mutation;
exports.DevelopmentSettingsSelector = DevelopmentSettingsSelector;
exports.areasFromFragmentAreas = areasFromFragmentAreas;
exports.make = make;
/* commitMutation Not a pure module */
